<app-alert-v2 #alert></app-alert-v2>
@if (appVersionService.updateState$ | async; as versionState) {
  @if (versionState === 'updating' || versionState === 'reloading') {
    <app-shared-loading
      [phaseLabel]="versionState === 'reloading' ? 'Recargando aplicación' : 'Actualizando aplicación'"
      [message]="'Puedes abrir Actualizar para acceder a la recuperación.'"
      [showRetry]="false"
      (retry)="retryVersionUpdate()">
    </app-shared-loading>
  } @else if (bootCoordinator.snapshot$ | async; as boot) {
    @if (boot.state === 'booting' || boot.state === 'warming' || boot.state === 'error') {
      <app-shared-loading
        [progress]="boot.progress"
        [phaseLabel]="boot.phaseLabel"
        [message]="boot.state === 'error' ? 'No se pudo completar el inicio. Reintenta o abre Actualizar para recuperar la aplicación.' : ''"
        [showRetry]="boot.state === 'error'"
        (retry)="bootCoordinator.retry()">
      </app-shared-loading>
    }
  }
  @if (appVersionService.updatePanelOpen || router.url.split('?')[0] === '/login' || (bootCoordinator.snapshot$ | async)?.state === 'error' || versionState === 'updating' || versionState === 'reloading') {
  <details class="app-update-panel" [open]="appVersionService.updatePanelOpen || versionState === 'available' || versionState === 'error'">
    <summary (click)="appVersionService.updatePanelOpen = false">Actualizar <span class="app-update-version">{{ appVersionService.currentVersion }}</span></summary>
    <div class="app-update-content">
      <p role="status" aria-live="polite">{{ (appVersionService.statusMessage$ | async) || 'Busca una nueva versión de la aplicación.' }}</p>
      <p class="app-update-hint">Guarda tus cambios antes de actualizar o reparar.</p>
      <button type="button" (click)="retryVersionUpdate()" [disabled]="versionState === 'updating' || versionState === 'reloading'">
        {{ versionState === 'updating' ? 'Preparando actualización…' : versionState === 'available' ? 'Actualizar ahora' : 'Buscar actualización' }}
      </button>
      <button type="button" class="app-update-repair" (click)="appVersionService.openRecoveryPage()">Reparar actualización</button>
      @if (appVersionService.updatePanelOpen) {
        <button type="button" class="app-update-repair" (click)="appVersionService.updatePanelOpen = false">Cerrar</button>
      }
    </div>
  </details>
  }
}
<div *ngIf="realtimeCoordinator.permissionPrompt$ | async" class="push-consent-banner">
  <div class="push-consent-copy">
    <strong>Activa notificaciones</strong>
    <span>Recibe alertas de tareas, mensajes y agenda incluso cuando no tengas la app al frente.</span>
  </div>
  <button type="button" class="push-consent-btn" (click)="enablePushNotifications()">Activar</button>
</div>
<div class="app-container">
  <router-outlet></router-outlet>
</div>
